const DEFAULT_TIPO_RESERVA = 'sin_asiento';

function hasItems(value) {
    return Array.isArray(value) && value.length > 0;
}

export function resolveTipoReserva(payload = {}) {
    if (hasItems(payload.butacas) || hasItems(payload.asientos)) {
        return 'asiento';
    }

    if (hasItems(payload.plazas)) {
        return 'plaza';
    }

    return DEFAULT_TIPO_RESERVA;
}

export { DEFAULT_TIPO_RESERVA };
